import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import CustomerDashboardHeader from "./CustomerHeader";
import CustomerDashboardSidebar from "./CustomerSidebar";
import "../../assets/css/layout/customer/CustomerLayout.css";


/* ── Route → Page Title map ── */
const pageTitleMap = {
  "/customer/dashboard":     { title: "Dashboard",         breadcrumb: " " },
//   "/customer/appointments":  { title: "My Appointments",   breadcrumb: "Home / Appointments" },
//   "/customer/book":          { title: "Book Appointment",  breadcrumb: "Home / Book New" },
//   "/customer/treatments":    { title: "My Treatments",     breadcrumb: "Home / Treatments" },
//   "/customer/deals":         { title: "Deals & Offers",    breadcrumb: "Home / Deals" },
//   "/customer/blog":          { title: "Blog & Tips",       breadcrumb: "Home / Blog" },
//   "/customer/notifications": { title: "Notifications",     breadcrumb: "Home / Notifications" },
//   "/customer/profile":       { title: "My Profile",        breadcrumb: "Home / Profile" },
//   "/customer/support":       { title: "Support",           breadcrumb: "Home / Support" },
};

const CustomerLayout = ({
  customerName,
  notificationCount,
  sidebarOpen,
  onToggleSidebar,
  onCloseSidebar,
}) => {
  const location = useLocation();
  const currentPage =
    pageTitleMap[location.pathname] || { title: "Dashboard", breadcrumb: "" };

  return (
    <div className="sgc-layout">

      {/* ── Sidebar (fixed left) ── */}
      <CustomerDashboardSidebar
        isOpen={sidebarOpen}
        onClose={onCloseSidebar}
      />

      {/* ── Header (fixed top) ── */}
      <CustomerDashboardHeader
        pageTitle={currentPage.title}
        breadcrumb={currentPage.breadcrumb}
        notificationCount={notificationCount || 0}
    customerName={
  JSON.parse(localStorage.getItem("customerData"))?.fullname || ""
}
        onToggleSidebar={onToggleSidebar}
      />

      {/* ── Main Content ── */}
      {/*
        margin-left: 260px  → pushes content right of sidebar
        margin-top:  70px   → pushes content below header
      */}
      <main className="sgc-layout-main">
        <div className="sgc-layout-content">
          <Outlet />
        </div>
      </main>

    </div>
  );
};

export default CustomerLayout;
